import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const STORAGE_KEY = "burnsEliteAdminPassword";

export const getStoredAdminPassword = () => localStorage.getItem(STORAGE_KEY) || "";
export const setStoredAdminPassword = (pw) => localStorage.setItem(STORAGE_KEY, pw);
export const clearStoredAdminPassword = () => localStorage.removeItem(STORAGE_KEY);

// axios instance for ALL admin requests. Always sends the stored password as
// X-Admin-Password. On 401, wipes the stored password and reloads (forcing the
// login screen) so an expired/wrong password never silently no-ops.
export const adminApi = axios.create({ baseURL: API_BASE });

adminApi.interceptors.request.use((config) => {
  const pw = getStoredAdminPassword();
  if (pw) {
    config.headers = config.headers || {};
    config.headers["X-Admin-Password"] = pw;
  }
  return config;
});

adminApi.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error?.response?.status === 401) {
      clearStoredAdminPassword();
      // Defer reload so the calling component can show its own toast first.
      setTimeout(() => window.location.reload(), 50);
    }
    return Promise.reject(error);
  }
);

// Public (unauthenticated) axios instance, for endpoints that don't need auth.
export const publicApi = axios.create({ baseURL: API_BASE });

export const ADMIN_API_BASE = API_BASE;
